module.exports = __webpack_public_path__ + "static/media/extend.42b36e94.png";